import { createContext, useContext } from 'react';

export const LibraryOnboardingContext = createContext(false);
export const useLibraryOnboardingReady = () => useContext(LibraryOnboardingContext);

export const isLibraryOnboardingReady = ({ viewedIntro, welcomeOpen, locationKey, closedLocationKey }) => (
  viewedIntro === true && !welcomeOpen && locationKey !== closedLocationKey
);
